export default "__VITE_ASSET__CBycmLi5__"